import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../atoms/Image';
import './SpecialImageCaption.css';
import SpecialPrice from '../Special/components/SpecialPriceVariation';

const SpecialImageCaption = props => {
  const { gatsbyImage = {}, image, name, description, variations, category, precision } = props;
  return (
    <div className="special-image-caption-container">
      <Image
        imageQuery={gatsbyImage.childImageSharp}
        src={image}
        alt={name}
        background
        className="special-image-caption"
      >
        <div className="special-image-caption-text-block">
          <div className="special-image-caption-caption">
            <h2 className="special-image-caption-title">{name}</h2>
            {category && <h4 className="special-image-caption-title-category">{category}</h4>}
            <span className="special-image-caption-description">{description}</span>
            <SpecialPrice variations={variations} precision={precision} />
          </div>
        </div>
      </Image>
    </div>
  );
};

SpecialImageCaption.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  variations: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
};

export default SpecialImageCaption;
